import { Component, ViewChild, Input, Output, EventEmitter, forwardRef, OnInit, input, Signal, inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { TypeaheadMatch, TypeaheadDirective } from 'ngx-bootstrap/typeahead';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HighlightPipe } from '../../helpers/highlight.pipe';
import { CompareTextPipe } from '../../helpers/compareText.pipe';
import { AuthService } from 'core';

@Component({
  selector: 'or-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GlobalSearchComponent),
      multi: true
    },HighlightPipe, CompareTextPipe
  ]
})
export class GlobalSearchComponent implements ControlValueAccessor, OnInit {
  @Input() formControlName = '';
  @ViewChild('typeaheadDirective') typeaheadDirective: TypeaheadDirective;
  @Input() dataCallback;
  @Input() labelField = 'label';
  @Input() recentSearches = [];
  @Output() valueChange = new EventEmitter();
  @Input() isInternal = false;

  private auth = inject(AuthService);

  listenerFn: () => void;
  asyncSearch: string;
  dataSource: Observable<any>;
  typeaheadLoading: boolean;
  typeaheadNoResults: boolean;
  activeFilter = '';
  hoveredSearchItem = false;
  matches?: any;
  resultsCount: number;
  pressedItem=null;
  hoveredItem: any = null;
  isClient = false;

  constructor() { }

  ngOnInit() {
    this.isClient = this.auth.isClient();
    this.dataSource = new Observable((observer: Observer<any>) => {
      return this.dataCallback(this.asyncSearch).subscribe((items: any) => {
        observer.next(items);
        this.getResultsCount(items);
      });
    });
  }

  public onFocus(e: Event): void {
    /*e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event('input');
      e.target.dispatchEvent(inputEvent);
    }, 0);*/
    this.typeaheadDirective.show();
  }
 public onInput(event: any, typeaheadDirective: any) {
    const value = event.target.value;
    this.asyncSearch = value;
    if (!value) {
      // If input is empty, force open the dropdown manually
      // Slight delay because bs-typeahead tries to close it immediately
      setTimeout(() => {
        if (!typeaheadDirective.isOpen) {
          typeaheadDirective.show();
        }
      });
    }
  }
  onSelect(match: TypeaheadMatch): void {
    this.asyncSearch = '';
    this.valueChange.emit(match.item);
  }
  recentSearchSelect(item: any,$event){
    $event.preventDefault();
    this.asyncSearch = '';
    this.typeaheadDirective.hide();
    this.valueChange.emit(item);
  }
  onTypeaheadNoResults(event: boolean): void {
    this.typeaheadNoResults = event;
  }

  onTypeaheadLoading(event: boolean): void {
    this.typeaheadLoading = event;
  }

  writeValue(value: any): void {
  }

  registerOnChange(fn: any): void {
    this.listenerFn = fn;
  }

  registerOnTouched(fn: any): void {
  }

  showItem(resultType){
    if(this.activeFilter == 'projects'){
      if(resultType == 'summary' || resultType=='project'){
        return true;
      }
      else{
        return false;
      }
    }
    else if(this.activeFilter  == 'team'){
      if(resultType == 'user'){
        return true;
      }
      else{
        return false;
      }
    }
    else if(this.activeFilter  == 'clients'){
      if(resultType == 'client' || resultType=='client_user' ){
        return true;
      }
      else{
        return false;
      }
    }
    else if(this.activeFilter  == 'vendors'){
      if(resultType == 'vendor' || resultType=='vendor_user'){
        return true;
      }
      else{
        return false;
      }
    }
    return true;
  }
  setActiveFilter(filter){
    if(this.activeFilter == filter){
      this.activeFilter = '';
    }
    else{
      this.activeFilter = filter;
    }
    this.getResultsCount(this.matches);
  }
  getSearchText(resultType){
    if(resultType == 'summary')
      return 'Summary';
    else if(resultType == 'project')
      return 'Project'
    else if(resultType == 'user')
      return 'Team'
    else if(resultType == 'client' || resultType == 'client_user')
      return 'Client'
    else if(resultType == 'vendor' || resultType == 'vendor_user')
      return 'Vendor'

  }

  getResultsCount(matches){
    var matchCount = -1;
    if(matches){
      this.matches = matches;
      matchCount = matches.length;
      if(this.activeFilter != ''){
        matchCount = 0;
        for(const match of matches){
          var resultType = match.type;
          if(this.activeFilter == 'projects'){
            if(resultType == 'summary' || resultType=='project'){
              matchCount++;
            }
          }
          else if(this.activeFilter  == 'team'){
            if(resultType == 'user'){
              matchCount++;
            }
          }
          else if(this.activeFilter  == 'clients'){
            if(resultType == 'client' || resultType=='client_user' ){
              matchCount++;
            }
          }
          else if(this.activeFilter  == 'vendors'){
            if(resultType == 'vendor' || resultType=='vendor_user'){
              matchCount++;
            }
          }
        }
      }
    }
    this.resultsCount = matchCount;
  }
}
